import { Component, Input } from '@angular/core'

@Component({
	selector: 'app-image',
	templateUrl: './image.component.html',
	styleUrl: './image.component.scss',
})
export class ImageComponent {
	@Input() imageSrc: string | null = null
	@Input() imageAlt: string = 'image'
	@Input() imageWidth: string = '100%'
}
